export default __webpack_public_path__ + "static/mstile-150x150-276a61db0022cb7993fa2c086c9eeaff.png";